import React from "react";
import { getFieldValue } from "@sitecore-jss/sitecore-jss-react";
import Helmet from "react-helmet";

const ChatBot = ({ fields }) => {
  // Fields
  const pageType = getFieldValue(fields, "pageType");
  const state = getFieldValue(fields, "state");
  const areaName = getFieldValue(fields, "areaName");
  const communityNumber = getFieldValue(fields, "communityNumber");
  const communityName = getFieldValue(fields, "communityName");
  const planNumber = getFieldValue(fields, "planNumber");
  const planName = getFieldValue(fields, "planName");

  return (
    <Helmet>
      <script defer>{`
        dataLayer = [{
          "atlasSettings": {
            "pageType": "${pageType}",
            "state": "${state}",
            "areaName": "${areaName}",
            "communityNumber": "${communityNumber}",
            "communityName": "${communityName}",
            "planNumber": "${planNumber}",
            "planName": "${planName}"
          }
        }];
      `}</script>
    </Helmet>
  );
};

export default ChatBot;
